import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { useBackButtonStyles as makeBackButtonClass } from 'kineticUtils';

const useBackButtonStyles = makeStyles(({ palette, spacing, typography }) => {
  const backButtonClass = makeBackButtonClass(typography, palette, spacing);
  return createStyles({
    ...backButtonClass,
    arrowBack: {
      fontSize: '.9rem',
    },
    backButtonTitle: {
      fontSize: 12,
      paddingTop: 1,
    },
  });
});

export default useBackButtonStyles;
